import { useEffect, useState } from "react";
import api from "@/lib/api";
import { terminalState } from "@/lib/wallet";
import { MODULE_CARDS, QUICK_ACTIONS, TileGrid } from "./tiles";
import { ClockCard, IdentityCard, MyShiftCard, OpenShiftsCard, StockAlertCard, PickupsCard, RegisterCard, ConnectivityCard } from "./ops";

// Manager: operational signals only — the server payload for this role carries no monetary keys.
export function ManagerDashboard({ stats }) {
  return (
    <div className="space-y-8" data-testid="manager-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        <ClockCard />
        <IdentityCard />
        <MyShiftCard shift={stats?.my_shift} />
        <OpenShiftsCard count={stats?.open_shift_count} />
        <StockAlertCard low={stats?.low_stock} out={stats?.out_of_stock} />
        <PickupsCard count={stats?.pickups_pending} />
      </div>
      <TileGrid title="Business Modules" items={MODULE_CARDS} testid="business-modules" />
    </div>
  );
}

// Cashier: register + shift state only. Zero monetary information by CEO requirement.
export function CashierDashboard({ stats }) {
  const [terminal, setTerminal] = useState(null);
  useEffect(() => { terminalState(api).then(setTerminal); }, []);
  return (
    <div className="space-y-8" data-testid="cashier-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        <ClockCard />
        <IdentityCard />
        <RegisterCard terminal={terminal} />
        <MyShiftCard shift={stats?.my_shift} />
        <ConnectivityCard />
      </div>
      <TileGrid title="Quick Actions" items={QUICK_ACTIONS} testid="quick-actions" />
    </div>
  );
}
